import { EventCast, Reaction, Comment } from "applesauce-common/casts";
import { CommentsModel, ReactionsModel } from "applesauce-common/models";
import { castTimelineStream } from "applesauce-common/observable";
import {
  getAddressPointerForEvent,
  getOrComputeCachedValue,
  getTagValue,
  NostrEvent,
} from "applesauce-core/helpers";
import { naddrEncode } from "nostr-tools/nip19";

import { WIFI_NETWORK_KIND } from "../const";
import { getLatLongFromEvent } from "../helpers/geohash";

const WifiValuesSymbol = Symbol.for("wifistr/wifi-values");

function isWifiNetwork(event: NostrEvent) {
  return event.kind === WIFI_NETWORK_KIND;
}

export class WifiNetwork extends EventCast {
  constructor(event: NostrEvent, store: ConstructorParameters<typeof EventCast>[1]) {
    if (!isWifiNetwork(event)) throw new Error("Invalid WiFi network event");
    super(event, store);
  }

  private get values() {
    return getOrComputeCachedValue(this.event, WifiValuesSymbol, () => ({
      name: getTagValue(this.event, "name"),
      ssid: getTagValue(this.event, "ssid"),
      password: getTagValue(this.event, "password"),
      security: getTagValue(this.event, "security"),
      hidden: getTagValue(this.event, "h") === "true",
      captive: getTagValue(this.event, "c") === "true",
      location: getLatLongFromEvent(this.event),
      address: getAddressPointerForEvent(this.event),
    }));
  }

  get name() {
    return this.values.name;
  }

  get ssid() {
    return this.values.ssid;
  }

  get password() {
    return this.values.password;
  }

  get security() {
    return this.values.security;
  }

  get hidden() {
    return this.values.hidden;
  }

  get captive() {
    return this.values.captive;
  }

  get location() {
    return this.values.location;
  }

  get description() {
    return this.event.content;
  }

  get address() {
    return this.values.address;
  }

  get naddr() {
    return this.address ? naddrEncode(this.address) : undefined;
  }

  get comments$() {
    return this.$$ref("comments$", (store) =>
      store
        .model(CommentsModel, this.event)
        .pipe(castTimelineStream(Comment, store)),
    );
  }

  get reactions$() {
    return this.$$ref("reactions$", (store) =>
      store
        .model(ReactionsModel, this.event)
        .pipe(castTimelineStream(Reaction, store)),
    );
  }
}
